import { call, put, takeEvery } from 'redux-saga/effects';
import { filterSearch } from '../../requests/filter_search_request';
import { countBikeModels } from '../../requests/get_all_bikes_request';
import { filterSearchRequestSuccess, filterSearchRequestFailure } from '../actions/filter_search.actions';
import { FILTER_SEARCH_REQUEST } from '../constants/bike_model.constants';
import { countBikeModelsRequestFailure, countBikeModelsRequestSuccess } from '../actions/count_bike_models.actions';
import { allFalse } from '../../../../../shared/helpers';

function* filterSearchSagaRequest({ where }) {
    const { result, options, error } = yield call(filterSearch, where);
    if (result) {
        yield put(filterSearchRequestSuccess(options));
        if (allFalse(where)) {
            yield put(countBikeModelsRequestSuccess(0));
        } else {
            const { result, options: { amount }, error } = yield call(countBikeModels, where);
            result
                ? yield put(countBikeModelsRequestSuccess(amount))
                : yield put(countBikeModelsRequestFailure(error));
        }
    } else {
        yield put(filterSearchRequestFailure(error));
    }
}

export default function* filterSearchSaga() {
    yield takeEvery(FILTER_SEARCH_REQUEST, filterSearchSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/filter_search.saga.js